import React from 'react'
import {useNavigate, useParams} from "react-router-dom";
import {ModeleClientAdresse, modeleClientAdresseInitValues} from "../../../../../../components/Models";
import {createClientAdresse} from "../../../../../../components/requests";
import {ClientAdresseForm} from "../../components/ClientAdresseForm";

const ClientAdresseAdd = () => {
    const navigate = useNavigate();
    let { clientId } = useParams();
    const submitForm = async (fieldsToUpdate: Partial<ModeleClientAdresse>, callback): Promise<void> => {
        const updatedData = Object.assign({...modeleClientAdresseInitValues}, fieldsToUpdate)

        var requestOk = false;
        try {
            const clientAdresseRequest = await createClientAdresse(clientId, updatedData);
            if (clientAdresseRequest?.status === 200) {
                if (clientAdresseRequest?.data?.id !== undefined && clientAdresseRequest?.data?.id !== null) {
                    requestOk = true;
                }
            }
        } catch (ex) {
            console.error(ex)
        } finally {
            callback();
            if (requestOk) {
                navigate(`/vente/clients/${clientId}/afficher/adresses`);
            }
        }

    }

    return (
        <div className='card mb-5 mb-xl-10'>
            <div
                className='card-header border-0'
            >
                <div className='card-title m-0'>
                    <h3 className='fw-bolder m-0'>Créer une adresse</h3>
                </div>
            </div>

            <div>
                <ClientAdresseForm clientId={clientId} adresseId={null} data={modeleClientAdresseInitValues} submitForm={submitForm} />
            </div>
        </div>
    )
}

export {ClientAdresseAdd}
